export default "__VITE_ASSET__BH45Cjks__"